import { Field, Form, Formik, FormikHelpers } from "formik";
import { useTranslation } from "react-i18next";
import { Button, Col, Container, Row } from "reactstrap";
import * as Yup from "yup";
import { useGetAllPlacesList } from "../../Parameters/Geographicals/Places/api/getAllPlacesList";
import { useGetAllModemsList } from "../../Parameters/Equipment/Modems/api/getAllModemsList";


const EditDCompanyForm = ({ initialValues, onSubmit }: EditDCompanyFormProps) => {
    const { t } = useTranslation();

    const getAllPlacesListQuery = useGetAllPlacesList();
    const getAllModemsListQuery = useGetAllModemsList();
    

    const validationSchema= Yup.object({
      description: Yup.string().required('Το πεδίο είναι υποχρεωτικό'),
      unID:Yup.string().required('Το πεδίο είναι υποχρεωτικό'),
    })

    return (
      <Formik
        enableReinitialize
        initialValues={initialValues}
        onSubmit={(values, formikHelpers) => {
            onSubmit(values, formikHelpers);
          }
        }
        validationSchema={validationSchema}
      >
        {({ errors, touched, isSubmitting, values, getFieldProps }) => (
        <Form>
        <Container fluid className="p-0">
        <Row>
          <Col xs={6}>
              <label className="form-label">
                {`${t("Περιγραφή")}*`}
              </label>
              <Field
                name="description"
                className="form-control"
                placeholder=""
                type="text"
                field="description"
               
              />
              <div className="text-danger">
                {errors.description && touched.description && (
                  <div>{errors.description}</div>
                )}
              </div>
            </Col>
            <Col xs={6}>
              <label className="form-label">
                {`${t("Τοποθεσία")}`}
              </label>
              <Field
                as="select"
                name="placeID"
                className="form-control"
                placeholder=""
                type="text"
                field="placeID"
              >
              <option value="">{t("Επιλέξτε Τοποθεσία")}</option>
              {getAllPlacesListQuery.data &&
                getAllPlacesListQuery.data.map((place) => (
                  <option key={place.id} value={place.id}>
                    {place.name}
                  </option>
                ))}
            </Field>
              <div className="text-danger">
                {errors.placeID && touched.placeID && (
                  <div>{errors.placeID}</div>
                )}
              </div>
            </Col>
            <Col xs={6}>
              <label className="form-label">
                {`${t("Modem")}`}
              </label>
              <Field
                as="select"
                name="modemID"
                className="form-control"
                placeholder=""
                type="text"
                field="modemID"
              >
              <option value="">{t("Επιλέξτε Modem")}</option>
              {getAllModemsListQuery.data &&
                getAllModemsListQuery.data.map((modem) => (
                  <option key={modem.id} value={modem.id}>
                    {modem.description}
                  </option>
                ))}
            </Field>
              <div className="text-danger">
                {errors.modemID && touched.modemID && (
                  <div>{errors.modemID}</div>
                )}
              </div>
            </Col>
            <Col xs={6}>
              <label className="form-label">
                {`${t("Θύρα Modem")}`}
              </label>
              <Field
                name="modemPort"
                className="form-control"
                placeholder=""
                type="text"
                field="modemPort"
               
              />
              <div className="text-danger">
                {errors.modemPort && touched.modemPort && (
                  <div>{errors.modemPort}</div>
                )}
              </div>
            </Col>
            <Col xs={6}>
              <label className="form-label">
                {`${t("Κωδικός Μονάδας")}*`}
              </label>
              <Field
                name="unID"
                className="form-control"
                placeholder=""
                type="text"
                field="unID"
               
              />
              <div className="text-danger">
                {errors.unID && touched.unID && (
                  <div>{errors.unID}</div>
                )}
              </div>
            </Col>
            <Col xs={6}>
              <label className="form-label">
                {`${t("Κωδικός SAP")}`}
              </label>
              <Field
                name="sapCode"
                className="form-control"
                placeholder=""
                type="text"
                field="sapCode"
               
              />
              <div className="text-danger">
                {errors.sapCode && touched.sapCode && (
                  <div>{errors.sapCode}</div>
                )}
              </div>
            </Col>
            <Col xs={4}>
              <label className="form-label">
                {`${t("Εμπορική")}`}
              </label>
              <Field
                type="checkbox"
                name="isEmporiki"
                field="isEmporiki"
              />
              <div className="text-danger">
                {errors.isEmporiki && touched.isEmporiki && (
                  <div>{errors.isEmporiki}</div>
                )}
              </div>
            </Col>

            <Col xs={4}>
              <label className="form-label">
                {`${t("Citibank")}`}
              </label>
              <Field
                type="checkbox"
                name="isCiti"
                field="isCiti"
              />
              <div className="text-danger">
                {errors.isCiti && touched.isCiti && (
                  <div>{errors.isCiti}</div>
                )}
              </div>
            </Col>

            <Col xs={4} className="d-none">
              <label className="form-label">
                {`${t("Διεγραμμένο")}`}
              </label>
              <Field
                type="checkbox"
                name="deleted"
                field="deleted"
              />
              <div className="text-danger">
                {errors.deleted && touched.deleted && (
                  <div>{errors.deleted}</div>
                )}
              </div>
            </Col>

            <Col xs={6}>
              <label className="form-label">
                {`${t("Τύπος HUB")}`}
              </label>
              <Field
                name="hubType"
                className="form-control"
                placeholder=""
                type="text"
                field="hubType"
               
              />
              <div className="text-danger">
                {errors.hubType && touched.hubType && (
                  <div>{errors.hubType}</div>
                )}
              </div>
            </Col>

            <Col xs={6}>
              <label className="form-label">
                {`${t("AlphaNet Voice")}`}
              </label>
              <Field
                name="anetVoice"
                className="form-control"
                placeholder=""
                type="text"
                field="anetVoice"
               
              />
              <div className="text-danger">
                {errors.anetVoice && touched.anetVoice && (
                  <div>{errors.anetVoice}</div>
                )}
              </div>
            </Col>

            <Col xs={6} className="d-none">
              <label className="form-label">
                {`${t("Φυσικό Interface")}`}
              </label>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <Field
                  name="physicalIFID"
                  className="form-control"
                  placeholder=""
                  type="text"
                  field="physicalIFID"
                  disabled
                />
                {/* <Button
                  type="button"
                  size="sm"
                  styletype="primary"
                  disabled={isSubmitting}
                  onClick={() => handleInterfaceButtonClick('physicalIFID')}
                >
                  {t("Αλλαγή")}
                </Button> */}
              </div>
            </Col>

            <Col xs={6} className="d-none">
              <label className="form-label">
                {`${t("Remote Interface")}`}
              </label>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <Field
                  name="logicalIFID"
                  className="form-control"
                  placeholder=""
                  type="text"
                  field="logicalIFID"   
                  disabled              
                />
               {/*  <Button
                type="button"
                size="sm"
                styletype="primary"
                disabled={isSubmitting}
                onClick={() => handleInterfaceButtonClick('logicalIFID')}
                >
                {t("Αλλαγή")}
                </Button> */}
              </div>
            </Col>

            <Col xs={6}>
              <label className="form-label">
                {`${t("Υπάγεται στο")}`}
              </label>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <Field
                  name="fallsUnder"
                  className="form-control"
                  placeholder=""
                  type="text"
                  field="fallsUnder"
                  disabled
                />
                {/* <Button
                  type="button"
                  size="sm"
                  styletype="primary"
                  disabled={isSubmitting}
                  onClick={() => handleFallsUnderButtonClick()}
                >
                  {t("Αλλαγή")}
                </Button> */}
              </div>
              <div className="text-danger">
                {errors.fallsUnder && touched.fallsUnder && (
                  <div>{errors.fallsUnder}</div>
                )}
              </div>
            </Col>

            <Col xs={6}>
              <label className="form-label">
                {t("Σχόλια")}
              </label>
              <Field
                type="text"
                name="comments"
                field="comments"
                className="form-control"
                as="textarea"
              />
              <div className="text-danger">
                {errors.comments && touched.comments && (
                  <div>{errors.comments}</div>
                )}
              </div>
            </Col>

            <Col xs={6}>
              <label className="form-label">
                {`${t("Αρχείο Διαγράμματος")}`}
              </label>
              <Field
                name="filepath"
                className="form-control"
                placeholder=""
                type="text"
                field="filepath"
               
              />
              <div className="text-danger">
                {errors.filepath && touched.filepath && (
                  <div>{errors.filepath}</div>
                )}
              </div>
            </Col>
        
          </Row>
        </Container>

        <div className="mb-3">
          <Button
            type="submit"
            size="sm"
            styletype="primary"
            disabled={isSubmitting}
          >
            {t("Αποθήκευση")}
          </Button>
        </div>
      </Form>
      )}
      </Formik>
  )
}

export default EditDCompanyForm;

type EditDCompanyFormProps =
   {
      initialValues: IEditDCompanyForm;
      onSubmit: (
        values: IEditDCompanyForm,
        formikHelpers: FormikHelpers<IEditDCompanyForm>
      ) => void;
    }
  

